<div class="title">
  <i [class]="icon"></i><span>{{ title | translate }}</span>
</div>
